var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"text-wrapper"},[_c('p',{staticClass:"text",style:(_vm.getStyle),domProps:{"innerHTML":_vm._s(_vm.element.label[_vm.$parent.language])}})])
}
var staticRenderFns = []

export { render, staticRenderFns }